import { Empty, Spin } from "antd";
import moment from "moment";
import React from "react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

// const CustomTooltip = ({ active, payload, label }) => {
//   console.log("average", payload[0])
// 	if (active) {
// 		return (
// 			<div className="custom-tooltip">
// 				<p className="label">{`${label} : ${payload[0].value}`}</p>
// 			</div>
// 		);
// 	}

// 	return null;
// };

const RenderLineChart = (props) => {
  // console.log("render", props.data, props.reference, props.average)
  if (!props.data) {
    return <Spin />;
  }
  if (props.data.length === 0) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }
  return (
    <ResponsiveContainer>
      <LineChart
        width={430}
        data={props.data}
        margin={{
          top: 5,
          right: 5,
          left: 0,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis
          dataKey="for_date"
          name="date"
          tickFormatter={(date) => moment(date).format("MM/DD")}
        />
        <YAxis domain={["auto", "auto"]} />
        <Tooltip />
        <Legend />
        {props.reference
          ? props.reference.map((referenceLine) => {
              return (
                <ReferenceLine
                  y={referenceLine.value}
                  stroke={referenceLine.color}
                  label={referenceLine.label}
                />
              );
            })
          : ""}
        {/** Show average lines -
         * TODO: refactor this, should behardcoded
         */}
        {props.average && props.data ? (
          <Line
            type="monotone"
            name="current Avg"
            dataKey="current_avg"
            stroke="#82ca9d"
          />
        ) : (
          ""
        )}
        {props.average && props.data ? (
          <Line
            type="monotone"
            name="previous Avg"
            dataKey="previous_avg"
            stroke="#FFC658"
          />
        ) : (
          ""
        )}

        {/** Main lines */}
        <Line
          type="monotone"
          name={props.dataline_name}
          dataKey={props.dataline}
          stroke="#8884d8"
          activeDot={{ r: 8 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default RenderLineChart;
